(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sliding-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faj-announcement')) {
    class FajAnnouncement extends HTMLElement {
      connectedCallback() {
        this.buildMarquee();
      }

      buildMarquee() {
        const track = this.querySelector('[data-faj-track]');
        const primarySequence = this.querySelector('[data-faj-primary]');
        const originalSet = this.querySelector('[data-faj-set]');

        if (!track || !primarySequence || !originalSet) {
          return;
        }

        /*
         * Clean up generated marquee copies if this element
         * is reconnected by the Shopify Theme Editor.
         */
        this.querySelectorAll('[data-faj-generated]').forEach((element) => {
          element.remove();
        });

        let repeatCount = parseInt(this.dataset.repeatCount || '1', 10);

        if (Number.isNaN(repeatCount) || repeatCount < 1) {
          repeatCount = 1;
        }

        /*
         * Duplicate the original message set when required.
         * The original set remains the Shopify-editable copy.
         */
        for (let index = 1; index < repeatCount; index += 1) {
          const repeatedSet = originalSet.cloneNode(true);

          repeatedSet.setAttribute('data-faj-generated', '');
          repeatedSet.setAttribute('aria-hidden', 'true');

          this.removeEditorAttributes(repeatedSet);

          primarySequence.appendChild(repeatedSet);
        }

        /*
         * Clone the complete primary sequence once.
         * Two identical sequences allow the CSS animation
         * to loop seamlessly using translateX(-50%).
         */
        const clonedSequence = primarySequence.cloneNode(true);

        clonedSequence.removeAttribute('data-faj-primary');

        clonedSequence.setAttribute('data-faj-generated', '');
        clonedSequence.setAttribute('aria-hidden', 'true');

        clonedSequence.classList.remove(
          'faj-announcement__sequence--primary'
        );

        clonedSequence.classList.add(
          'faj-announcement__sequence--clone'
        );

        this.removeEditorAttributes(clonedSequence);

        track.appendChild(clonedSequence);
      }

      removeEditorAttributes(root) {
        const attributesToRemove = [
          'data-shopify-editor-block',
          'data-shopify-editor-block-id',
          'data-shopify-editor-block-type'
        ];

        attributesToRemove.forEach((attribute) => {
          if (root.hasAttribute(attribute)) {
            root.removeAttribute(attribute);
          }
        });

        root.querySelectorAll('*').forEach((element) => {
          attributesToRemove.forEach((attribute) => {
            if (element.hasAttribute(attribute)) {
              element.removeAttribute(attribute);
            }
          });
        });
      }
    }

    customElements.define(
      'faj-announcement',
      FajAnnouncement
    );
  }

  } catch(e) { console.error(e); }
})();
})();
